import * as React from 'react'

import { User_user } from 'main/gql/user'
import ChildOnlyForm from './ChildOnlyForm'
import FullForm from './FullForm'
import PasswordOnlyForm from './PasswordOnlyForm'
import { isChildSectionRequired, isPasswordSectionRequired } from './util'

interface IProps {
  user: User_user
  cta?: string
  isOnboarding?: boolean
  onComplete: () => void
}

export default function IntermediateParentSignUpForm(props: IProps) {
  const { cta = 'Next', user, isOnboarding } = props

  const [showChildSection, showPasswordSection] = [
    isChildSectionRequired(user),
    isPasswordSectionRequired(user),
  ]

  const extraProps = { cta, isOnboarding, ...props }

  if (isOnboarding) {
    return <ChildOnlyForm {...extraProps} />
  } else if (showChildSection && showPasswordSection) {
    return <FullForm {...extraProps} />
  } else if (showChildSection) {
    return <ChildOnlyForm {...extraProps} />
  } else if (showPasswordSection) {
    return <PasswordOnlyForm {...extraProps} />
  } else {
    return null
  }
}
